import React, { PropsWithChildren } from 'react';
import { Pressable, View, useWindowDimensions, Text, Image, StyleProp, ViewStyle } from 'react-native';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import {GlobalVariables} from '../utils/globalVariables';

type SectionProps = PropsWithChildren<{
  items: itemsHeaderStepper[],
  indexStepShow: number,
  styleContent?: StyleProp<ViewStyle>,
  onPress?: any
}>;
function HeaderStepperComponent({ items, indexStepShow, styleContent, onPress }: SectionProps): JSX.Element {
  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout);
  return (
    <View style={[styles('generalContainer'), styleContent]}>
      {
        items.map((item, index) => {
          return (
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'center',
              }}
              key={index}>
              <Pressable
                style={[
                  styles('container'),
                ]}
                disabled={indexStepShow < index}
                onPress={(event) => {
                  if (onPress) {
                    onPress({ event: event, item: item, index: index });
						}
                }}
              >
                <View
                  style={[
                    styles('roundItem'),
                    indexStepShow < index && styles('disabled'),
                  ]}>
                  <Image style={[
                    item.icon === enumIconHeaderStepperComponent.file && styles('iconFile'),
                    item.icon === enumIconHeaderStepperComponent.profile && styles('iconProfile'),
                  ]} source={item.icon} />
                </View>
                <Text style={styles('text')}>
                  {item.title}
                </Text>
              </Pressable>
              {
                (index + 1) < items.length ?
                  <View style={[
                    styles('bar'),
                    indexStepShow < (index + 1) && styles('disabled'),
                  ]}/>
                  : null
              }
            </View>
          );
        })
      }
    </View>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  generalContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  container: {
    alignItems: 'center',
  },
  roundItem: {
    backgroundColor: GlobalVariables.colors.primary.kingBlue,
    width: 50,
    height: 50,
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconFile: {
    width: 22,
    height: 27,
  },
  iconProfile: {
    width: 20,
    height: 23,
  },
  text: {
    color: GlobalVariables.colors.primary.textColorBlue,
    marginTop: 10,
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    fontSize: 16,
    fontWeight: 'bold',
  },
  bar: {
    width: 143,
    height: 8,
    backgroundColor: GlobalVariables.colors.primary.kingBlue,
    marginTop: 21,
    marginLeft: -50,
    marginRight: -50,
    zIndex: -2,
  },
  disabled: {
    backgroundColor: GlobalVariables.colors.secondary.lightGrey,
    color: GlobalVariables.colors.secondary.white,
  },
}, {

});
export default HeaderStepperComponent;
export class itemsHeaderStepper {
  id?: any = '';
  icon: enumIconHeaderStepperComponent = enumIconHeaderStepperComponent.profile;
  title?: string = '';
}
export enum enumIconHeaderStepperComponent {
  profile = require('../source/icons/user.png'),
  file = require('../source/icons/file.png')
}
